import "./Login.scss";

import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Row,
} from "shards-react";

import { ReactComponent as Logo } from "../../../assets/img/homepage/form.svg";
import TextInput from "../../common/form/TextInput";
import { loginUser, socialLogin } from "../Auth/authActions";
import SocialLogin from "./SocialLogin/SocialLogin";
import LoadingOverlay from "react-loading-overlay";
import Navbar from "../../layout/Navbar/Navbar";
import { openModal, closeModal } from "../../common/modals/modalActions";
import SSORemovelModal from "../../common/modals/Modals/SSORemovelModal";

const mapState = (state) => ({
  loading: state.async.loading,
});

const actions = {
  loginUser,
  socialLogin,
  openModal,
  closeModal,
};

const Login = ({
  loginUser,
  handleSubmit,
  history,
  error,
  socialLogin,
  loading,
  openModal,
  closeModal,
}) => {
  useEffect(() => {
    // openModal('SSORemovelModal', {
    //     closeModal: closeModal
    //   });
  }, []);

  return (
    <Fragment>
      <Navbar />

      <Container className="login-form py-3" fluid>
        <Row form>
          <Col className="text-center text-white col" sm="12" lg="6">
            <div>
              <h3 className="">Welcome Back</h3>
              <h5 className="text-dark">
                Got more complaints for us? Let us hear you.
              </h5>
              <Logo className="svg" />
            </div>
          </Col>
          <Col sm="12" lg="6" className="p-3">
            <LoadingOverlay active={loading} spinner>
              <Card small>
                <CardHeader className="bg-secondary text-white text-center">
                  <h4 className="text-white">Login Form</h4>
                </CardHeader>
                <CardBody className="text-center">
                  <Form onSubmit={handleSubmit(loginUser)}>
                    <FormGroup className="text-left">
                      <label>Email</label>
                      <Field
                        name="email"
                        type="email"
                        placeholder="Enter Email"
                        component={TextInput}
                      />
                    </FormGroup>
                    <FormGroup className="text-left">
                      <label>Password</label>
                      <Field
                        name="password"
                        component={TextInput}
                        type="password"
                        placeholder="Enter Password"
                      />
                    </FormGroup>
                    <Button
                      theme="success"
                      type="submit"
                      className="text-center"
                    >
                      Log In
                    </Button>
                    <div className="text-center mx-auto">
                      {error && <label className="error-label">{error}</label>}
                    </div>
                    <Button
                      className="no-style"
                      onClick={() => openModal("ForgotPasswordModal")}
                    >
                      Forgot Password
                    </Button>

                    {/* <div className='divider'>Or</div>
                    <SocialLogin socialLogin={socialLogin} /> */}
                  </Form>
                </CardBody>
                <CardFooter className="text-center">
                  <div className="divider">Or</div>
                  <Button
                    theme="success"
                    pill
                    onClick={() => history.push("/register")}
                  >
                    Register
                  </Button>
                </CardFooter>
              </Card>
            </LoadingOverlay>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default withRouter(
  connect(mapState, actions)(reduxForm({ form: "LoginForm" })(Login))
);
